import { render, staticRenderFns } from "./TableContentCandidateList.vue?vue&type=template&id=5536f422&scoped=true"
import script from "./TableContentCandidateList.vue?vue&type=script&lang=js"
export * from "./TableContentCandidateList.vue?vue&type=script&lang=js"
import style0 from "./TableContentCandidateList.vue?vue&type=style&index=0&id=5536f422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536f422",
  null
  
)

export default component.exports